import { watch } from 'vue';

import useAwsPartnerCentral from '@/composables/useAwsPartnerCentral';
import useFeedDetails from '@/composables/useFeedDetails';
import usePolling from '@/composables/usePolling';
import { AWS_PARTNER_CENTRAL_DATA_SOURCE_TYPE } from '@/constants/data_sources';
import { captureException } from '@/errors';
import { useFeedsStore, useFlashesStore } from '@/stores';

/* Polls the feed when it goes into a syncing state */
export default function ({ feed }) {
  const feedsStore = useFeedsStore();
  const flashesStore = useFlashesStore();
  const { refreshAwsPartnerCentral } = useAwsPartnerCentral();
  // AWS Partner Central feeds aren't in FeedsStore, so refresh them via the
  // offline-partner composable instead of feedsStore.refreshFeed.
  const isAws = feed.integration.type === AWS_PARTNER_CENTRAL_DATA_SOURCE_TYPE;

  const { feedIsSyncing } = useFeedDetails({ feedId: feed.id });

  const { start: poll } = usePolling({
    interval: 3000,
    async poller() {
      if (isAws) await refreshAwsPartnerCentral();
      else await feedsStore.refreshFeed(feed.id);
    },
    shouldComplete() {
      return !feedIsSyncing.value;
    },
    onComplete() {
      flashesStore.addSuccessFlash({
        message: `Your ${feed.integration.friendly_name} data source has finished syncing`,
      });
    },
    onError(err) {
      captureException(err);
      flashesStore.addUnhandledError(err);
    },
  });

  let timeout = null;
  function startSyncing() {
    timeout = poll();
  }

  if (feedIsSyncing.value) startSyncing();
  watch(feedIsSyncing, (isSyncing) => {
    if (isSyncing && !timeout) startSyncing();
  });
}
